import isString from 'lodash-es/isString'
import omitBy from 'lodash-es/omitBy'
import isUndefined from 'lodash-es/isUndefined'

import { COMPONENTS } from '../transformers'
import { getDisplayName } from '../../components/utils'

export function h(Component, props, ...children) {
  const result = {
    __isComponent__: true,
    type: getComponentName(Component),
    props: omitBy(props || {}, isUndefined),
    children,
  }

  return omitBy(result, (val) => !val)
}

function getComponentName(Component) {
  if (isString(Component)) {
    return Component
  }

  const found = Object.entries(COMPONENTS)
    .find(entry => entry[1] === Component)

  if (!found) {
    throw new Error(`Missing mapping for Component "${getDisplayName(Component)}"`)
  }

  return found[0]
}

export function getTopCtx(ctx) {
  // We are looking for the context right bellow the root level
  if (!ctx.parentCtx?.root) {
    return getTopCtx(ctx.parentCtx)
  }

  return ctx
}
